const admin = {
  menu: 'Menu administracji',
  'add-new-queue': 'Dodaj nową kolejkę',
  'queues-management': 'Zarządzaj kolejkami',
  'users-management': 'Zarządzaj użytkownikami',
  'queues-report': {
    'header' : 'Raporty obecności kolejek',
    'queue-selector' : 'Wybierz kolejkę'
  }
};

export default admin;
